var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "card-item checkin-content" }, [
      _c(
        "div",
        {
          staticClass: "card-content columns is-multiline",
          attrs: { id: "checkin-welcome" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "text-content column is-two-thirds-fullhd is-offset-one-third-fullhd is-half-desktop is-offset-half-desktop is-full-tablet has-text-justified",
            },
            [
              _c("h3", [
                _vm._v(
                  "Hola " +
                    _vm._s(
                      _vm.$store.state.currentUser !== null
                        ? _vm.$store.state.currentUser.user.name
                        : ""
                    )
                ),
              ]),
              _c("h4", [_vm._v("Bienvenid@ a tu espacio privado")]),
              _c("img", {
                staticClass: "rocket-image column is-full is-hidden-desktop",
                attrs: {
                  src: require("../../../assets/img/checkin_cohete.svg"),
                },
              }),
              _c("p", { staticClass: "is-size-6" }, [
                _vm._v(
                  " Queremos ofrecerte la mejor experiencia poniendo a tu disposición un lugar donde puedas ver y realizar todas las actividades relacionadas a tu crédito en creditu.com. "
                ),
              ]),
              _c("br"),
              _vm._m(0),
              _c("div", { staticClass: "has-text-centered" }, [
                _c(
                  "div",
                  { staticClass: "button-content transition-slow complete" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-button-primary is-rounded",
                        attrs: { id: "continueButton" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({ name: "terms" })
                          },
                        },
                      },
                      [_vm._v(" Empecemos ")]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "is-size-6" }, [
      _vm._v(" 🙌 "),
      _c("strong", [_vm._v("Tendremos novedades y mejoras")]),
      _vm._v(
        " constantes, según las recomendaciones que nos den ustedes, nuestra comunidad. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }